import { useQuery } from "@tanstack/react-query";

import { getTimeline } from "../services/timeline";

export const useTimeline = (params: {
  orderId: string;
  timelineLimit: number;
}) =>
  useQuery({
    queryFn: getTimeline,
    queryKey: ["orders-timeline", params],
    retry: 2,
    staleTime: 30000,
  });
